export enum States {
  DESBLOQUEADO = 'DESBLOQUEADO',
  BLOQUEADO = 'BLOQUEADO',
  EN_REVISION = 'EN REVISION',
}
